export default "__VITE_ASSET__C72jo34D__"